import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer, colorBins } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';
import { useAppState } from 'components/contexts/State';
import getPinnedTooltipCoordinate from 'utils/getPinnedTooltipCoordinate';
 
export const SYSTEMICRAMP_LAYER_ID = 'systemicRampLayer';
 
const layerConfig = {
  title: 'Systemic Score Ramps',
};
 
function SystemicRampLayer() {
  const dispatch = useDispatch();
  const { systemicRampLayer } = useSelector((state) => state.carto.layers);
  const {pinnedTooltip, setPinnedTooltip} = useAppState();
  const source = useSelector((state) =>
    selectSourceById(state, systemicRampLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });
  const viewState = useSelector((state) => state.carto.viewState);
  const pointLineWidth = viewState.zoom >= 7 ? 7 :4;
  if (systemicRampLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: SYSTEMICRAMP_LAYER_ID,
      geoColumn: 'geom',
      stroked: false,
      filled: true,
      lineWidthMinPixels: pointLineWidth,
      lineWidthMaxPixels: 10,
      pickable: true,
      lineWidthScale: 1,
      visible: systemicRampLayer.visible,
      opacity: systemicRampLayer.opacity,
 
      getLineColor: colorBins({
        attr: 'Systemic_Score',
       domain: [2, 4, 6, 8, 9],
       colors: [
          [145, 53, 125, 51],
          [145, 53, 125, 102],
          [145, 53, 125, 153],
          [145, 53, 125, 204],
          [145, 53, 125, 255],
        ],
      }),
      coverage: 0.95,
      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: SYSTEMICRAMP_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad?.(data);
      },
 
      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              //includeColumns: ['h3'],
            }),
          };
        }
      },
      onClick: (info) => {
        if (info?.object) {
          const html = htmlForFeature({ feature: info.object });
          if (pinnedTooltip?.html === html) {
            setPinnedTooltip(null);
          } else {
            setPinnedTooltip({
              html,
               postMileInfo: info.object.properties,
              coordinate: getPinnedTooltipCoordinate(info),
            });
          }
        }
      },
    });
  }
}
 
export default SystemicRampLayer;